// @flow strict

import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './industryItem.module.less';

export const IndustryItem = ({ data }) => {
  return (
    <a href={data.href} className={styles.industryLink}>
      <div className={styles.industryItem}>
        <div className={styles.iconContainer}>
          <img
            src={data.iconSrc.publicURL}
            alt={data.iconAlt}
            className={styles.icon}
          />
        </div>
        <h3 className={styles.title}>
          {data.title}
        </h3>
      </div>
    </a>
  );
};

IndustryItem.propTypes = {
  data: PropTypes.object,
};